import { useBrandLoaderData } from "routes/root/rootLoader";
import { useCoursesLoaderData } from "./coursesLoader";
import { useLayoutData } from "../layout/myCoursesLayoutLoader";
import useSingleToast from "routes/root/core-ui/toast/useSingleToast";
import { useCallback, useEffect } from "react";
import SurveyToast from "./SurveyToast";
import useUserPreference from "routes/home/actions/user/useUserPreference";
import { UserPreferenceKey } from "common/api/decimal/methods/user";

export default function useSurveyToast() {
  const { brand } = useBrandLoaderData();
  const { currentTerm } = useCoursesLoaderData();
  const { config, accessToken } = useLayoutData();
  const [showToast, closeToast] = useSingleToast({
    customId: "userSurveyToast",
  });
  const [
    userSurveyDismissedDate,
    setUserSurveyDismissed,
    deleteUserSurveyDismissed,
  ] = useUserPreference<string>(
    UserPreferenceKey.MyCoursesUserSurveyDismissedDate
  );

  const userSurveyDismissedDateIsValid = useCallback(() => {
    if (userSurveyDismissedDate) {
      const dismissedDate = new Date(userSurveyDismissedDate);
      const fourMonthsFromDismissedDate = new Date(
        dismissedDate.setMonth(dismissedDate.getMonth() + 4)
      );
      return fourMonthsFromDismissedDate >= new Date();
    }
    return false;
  }, [userSurveyDismissedDate]);

  const onInteract = useCallback(() => {
    setUserSurveyDismissed(new Date().toISOString());
    closeToast();
  }, [setUserSurveyDismissed, closeToast]);

  const shouldShowUserSurvey =
    config.userSurvey.show &&
    !!config.userSurvey.url &&
    !userSurveyDismissedDateIsValid();

  const termId = currentTerm?.id ?? null;
  const programDecision = currentTerm?.programDecision ?? null;
  const href = `${config.userSurvey.url}?userToken=${accessToken}&term=${termId}&programDecision=${programDecision}&brand=${brand}`;

  useEffect(() => {
    if (shouldShowUserSurvey) {
      showToast(
        <SurveyToast
          selfClose={closeToast}
          onInteract={onInteract}
          href={href}
        />
      );
    }
  }, [shouldShowUserSurvey, href, closeToast, showToast, onInteract]);

  useEffect(() => {
    if (userSurveyDismissedDate && !userSurveyDismissedDateIsValid()) {
      deleteUserSurveyDismissed();
    }
  }, [
    userSurveyDismissedDate,
    userSurveyDismissedDateIsValid,
    deleteUserSurveyDismissed,
  ]);
}
